/**
 * Created by Dongyuhua on 2018/3/12.
 */
module.exports = {
  common: {
    more: "更多",
    videos: "视频",
    news: "新闻",
    showMore: "查看详情",
    companyName: "速得尔科技（北京）有限公司",
  },
  comheader: {
    nav: [
      {
        title: "首页",
        url: "/",
      },
      {
        title: "电子靶",
        url: "/etarget",
      },
      // {
      //   title: "激光射击",
      //   url: "/lasershooting",
      // },
      {
        title: "智能枪弹柜",
        url: "/erange",
      },
      {
        title: "软件与服务",
        url: "/service",
      },
      {
        title: "赛事新闻",
        url: "/articlelist",
      },
      {
        title: "关于我们",
        url: "/about/intro",
      },
    ],
  },
  comfooter: {
    title: "联系我们",
    subtitle: "",
    contextInfo: [
      "速得尔科技（北京）有限公司",
      "服务热线： 4006-747-313",
      "总机：010-82093400",
      "传真：010-82093499",
      "网址：www.suooter.com",
      "邮箱：info@suooter.com",
      "地址：北京市西三旗桥北金燕龙大厦三层",
      "邮编：100096",
    ],
    ewm: [
      { url: "./static/erweima-1.png", intro: "速得尔微信公众号" },
      { url: "./static/douyin.png", intro: "速得尔抖音号" },
      // {url:"../static/erweima-2.png",
      //   intro:"www.suooter.com"},
    ],
    linksite: {
      name: "友情链接",
      link: [
        {
          name: "中国射击协会",
          url: "http://www.shooting.org.cn/",
        },
        {
          name: "赛事网络直播",
          url: "http://live.supershooter.cn:8019/",
        },
      ],
    },
  },
  main: {
    mainBanner: {
      banner: [
        // {
        //   img: "../static/banner-23.jpg",
        //   title: "",
        //   link: "/",
        // },
        {
          img: "../static/banner-21.jpg",
          title: "",
          link: "/",
        },
        {
          img: "../static/banner-20.png",
          title: "",
          link: "/",
        },
        {
          img: "../static/banner-19.jpg",
          title: "",
          link: "/",
        },
        {
          img: "../static/banner-18.jpg",
          title: "",
          link: "/",
        },
        {
          img: "../static/banner-16.jpg",
          title: "",
          link: "/",
        },
        // {
        //   img: "../static/banner-14.jpg",
        //   title: "",
        //   link: "/article/141",
        // },
        // {
        //   img: "../static/banner-10.jpg",
        //   title: "",
        //   link: "/article/90",
        // },
      ],
    },
    mainProduct: {
      title: "产品与系统",
      subtitle: "Product & System",
      intro: [
        {
          linkUrl: "/etarget",
          title: "电子靶",
          content: "",
          imgUrl: "../static/product-1.jpg",
        },
        // {
        //   linkUrl: "/lasershooting",
        //   title: "激光射击",
        //   content: "",
        //   imgUrl: "../static/product-2.jpg",
        // },
        {
          linkUrl: "/erange",
          title: "智能枪弹柜",
          content: "",
          imgUrl: "../static/product-3.jpg",
        },
        {
          linkUrl: "/service?idx=1",
          title: "激光测试仪",
          imgUrl: "../static/product-4.jpg",
        },
        {
          linkUrl: "/service?idx=0",
          title: "射击比赛模拟系统",
          imgUrl: "../static/product-5.jpg",
        },
      ],
    },
    mainService: {
      title: "软件与服务",
      subtitle: "Software & Service",
      intro: [
        {
          linkUrl: "/service?idx=3",
          title: "赛事直播",
          content: "",
          imgUrl: "../static/server-1.png",
        },
        {
          linkUrl: "/service?idx=2",
          title: "超级射手",
          content: "",
          imgUrl: "../static/server-2.png",
        },
        {
          linkUrl: "/service?idx=4",
          title: "大数据服务",
          content: "",
          imgUrl: "../static/server-3.png",
        },
        {
          linkUrl: "/service?idx=5",
          title: "赛事支持",
          content: "",
          imgUrl: "../static/server-4.png",
        },
      ],
    },
    mainHonor: {
      title: "荣誉与成就",
      subtitle: "Honor & Achievement",
      intro: [
        {
          linkUrl: "#",
          title: "中国射击协会射击器材设备鉴定证书",
          imgUrl: "../static/honor-1.png",
        },
        {
          linkUrl: "#",
          title: "高新技术企业证书",
          imgUrl: "../static/honor-2.png",
        },
        {
          linkUrl: "#",
          title: "中关村信用促进会VIP会员单位",
          imgUrl: "../static/honor-3.png",
        },
        {
          linkUrl: "#",
          title: "速得尔拥有电子靶核心专利",
          imgUrl: "../static/honor-4.png",
        },
      ],
    },
    mainNews: {
      title: "赛事与新闻",
      subtitle: "Events & News",
      intro: [
        {
          linkUrl: "#",
          title: "中国射击协会射击器材设备鉴定证书",
          imgUrl: "../static/honor-1.png",
        },
        {
          linkUrl: "#",
          title: "高新技术企业证书",
          imgUrl: "../static/honor-2.png",
        },
        {
          linkUrl: "#",
          title: "中关村信用促进会VIP会员单位",
          imgUrl: "../static/honor-3.png",
        },
        {
          linkUrl: "#",
          title: "速得尔拥有电子靶核心专利",
          imgUrl: "../static/honor-4.png",
        },
      ],
    },
  },
  eTarget: {
    //电子靶数据信息
    secondnav: [
      {
        title: "10米声学靶",
        icon: "../static/10msheng.png",
        activeIcon: "../static/10msheng-fill.png",
        index: 0,
      },
      {
        title: "25米/50米声学靶",
        icon: "../static/25msheng.png",
        activeIcon: "../static/25msheng-fill.png",
        index: 1,
      },
      {
        title: "10米光学靶",
        icon: "../static/10mguang.png",
        activeIcon: "../static/10mguang-fill.png",
        index: 2,
      },
      {
        title: "25米/50米光学靶",
        icon: "../static/25mguang.png",
        activeIcon: "../static/25mguang-fill.png",
        index: 3,
      },
      {
        title: "冲刺射击靶",
        icon: "../static/ccsj.png",
        activeIcon: "../static/ccsj-fill.png",
        index: 4,
      },
      // {
      //   title: "军/警用电子靶",
      //   icon: "../static/jingyong.png",
      //   activeIcon: "../static/jingyong-fill.png",
      //   index: 5,
      // },
      {
        title: "射箭靶",
        icon: "../static/sj-1.png",
        activeIcon: "../static/sj-2.png",
        index: 6,
      },
      // {
      //   title: "300米军用自动报靶系统",
      //   icon: "../static/jingyong.png",
      //   activeIcon: "../static/jingyong-fill.png",
      //   index: 7,
      // },
    ],
    title: "电子靶",
    titleIcon: "../static/dianziba-img@2x.png",
    tabs: [
      {
        title: "10米声学电子靶",
        subTitle: "ST10T",
        intro: [
          "速得尔10米声学电子靶系统ST10T是中国射击协会认证的电子靶系统。ST10T适合各类气步枪和气手枪的训练和比赛。",
        ],
        foundImg: "../static/10mshengxue.png",
        icon: "../static/shengxue.png",
        tags: [
          "CSA认证",
          "高精度",
          "高可靠性",
          "高性价比",
          "全国赛事考验",
          "市场主导",
        ],
        merits: [
          "ST10T适用于气步枪、气手枪项目",
          "比赛控制系统支持所有10米气枪项目",
          // "最佳性价比的声学电子靶系统",
          "更容易操控的触控屏",
          "竞赛及训练的理想设备",
          "广泛被中国客户认可的电子靶",
          "通过中国射击协会认证",
        ],
        introImgs: [
          {
            imgs: "../static/target_10m_qbp5.png",
            description: "XXXX靶场10米声学靶",
          },
        ],
      },
      {
        title: "25米/50米声学电子靶",
        subTitle: "ST25T/50T",
        intro: [
          "速得尔25米/50米声学电子靶系统ST25T/ST50T是中国射击协会认证的电子靶系统。 适合各类运动手枪和运动步枪的训练和比赛。",
        ],
        foundImg: "../static/2550mshengxue.png",
        icon: "../static/shengxue.png",
        tags: [
          "CSA认证",
          "高精度",
          "高可靠性",
          "高性价比",
          "全国赛事考验",
          "市场主导",
        ],
        merits: [
          "ST25T适用于所有25米运动手枪项目",
          "ST50T适用于所有50米运动手枪和运动步枪项目",
          "比赛控制系统支持所有25米/50米项目",
          // "最佳性价比的声学电子靶系统",
          "更容易操控的触控屏",
          "竞赛及训练的理想设备",
          "广泛被中国客户认可的电子靶",
          "通过中国射击协会认证",
        ],
        introImgs: [
          {
            imgs: "../static/target_10m_qbp5.png",
            description: "25米/50米声学电子靶",
          },
        ],
      },
      {
        title: "10米光学电子靶",
        subTitle: "ST10L",
        // intro: [
        //   "速得尔10米光学电子靶系统ST10L是中国射击协会认证的电子靶系统。采用光学探测技术，无耗材。适合各类气步枪和气手枪的训练和比赛。",
        // ],
        intro: [
          "速得尔10米光学电子靶系统ST10L是中国射击协会认证的电子靶系统采用光学探测技术，目标靶无耗材、支持竞赛取证，可以触屏、线控自定义环值缩放和自动缩放显示弹着。适合各类气步枪和气手枪的训练和比赛。",
        ],
        foundImg: "../static/10mguangxue.png",
        icon: "../static/shengxue.png",
        tags: [
          "CSA认证",
          "高精度",
          "高可靠性",
          "高性价比",
          "全国赛事考验",
          "市场主导",
        ],
        merits: [
          "ST10L适用于所有气步枪、气手枪项目",
          "比赛控制系统支持所有10米气枪项目",
          // "采用国际最先进技术的光学电子靶系统",
          "免耗材、可靠性强",
          "更容易操控的触控屏",
          "竞赛及训练的理想设备",
          "通过国际射联（ISSF）一级认证",
          "经过中国射击协会认证电子靶",
          "通过国际射击联合会二级认证",
          "当前射击弹着点反馈时间0.1秒-0.2秒"
        ],
        introImgs: [
          {
            imgs: "../static/target_10m_qbp5.png",
            description: "10米光学电子靶",
          },
        ],
      },
      {
        title: "25米/50米光学电子靶",
        subTitle: "ST25L/50L",
        // intro: [
        //   "速得尔25米/50米光学电子靶系统ST25L/50L是中国射击协会认证的电子靶系统。采用光学探测技术，无耗材，适合各类运动手枪和运动步枪的训练和比赛。",
        // ],
        intro: [
          "速得尔25米/50米光学电子靶系统ST25L/50L是中国射击协会认证的电子靶系统。采用光学探测技术，目标靶无耗材,支持竞赛取证。ST25L弹着显示可单发、按组显示或所有弹着显示。ST50L可以触屏、线控自定义环值缩放和自动缩放显示弹着。适合各类运动手枪和运动步枪的训练和比赛。",
        ],
        foundImg: "../static/2550mguangxue.png",
        icon: "../static/shengxue.png",
        tags: [
          "CSA认证",
          "高精度",
          "高可靠性",
          "高性价比",
          "全国赛事考验",
          "市场主导",
        ],
        merits: [
          "ST25L适用于所有运动手枪项目",
          "比赛控制系统支持所有25米/50米项目",
          "采用国际先进光学探测技术的光学电子靶系统",
          "免耗材、可靠性强",
          "更容易操控的触控屏",
          "竞赛及训练的理想设备",
          "广泛被中国客户认可的电子靶",
          "通过中国射击协会认证",
          "通过国际射击联合会二级认证",
          "当前射击弹着点反馈时间0.1秒-0.2秒"
        ],
        introImgs: [
          {
            imgs: "../static/target_10m_qbp5.png",
            description: "25米/50米光学电子靶",
          },
        ],
      },
      {
        title: "冲刺射击靶",
        subTitle: "TS10E",
        intro: [
          "冲刺射击是将冲刺短跑与气枪射击有机结合的运动项目，由国际射联在2013年推出并在国际射联青少年世界杯中多次成功举行。速得尔率先在国内研制出符合国际射联规则的冲刺射击机电靶。",
        ],
        foundImg: "../static/chongcisheji.png",
        icon: "../static/shengxue.png",
        tags: [
          "CSA认证",
          "高精度",
          "高可靠性",
          "高性价比",
          "全国赛事考验",
          "市场主导",
        ],
        merits: [
          "电子自动报靶，更加便捷高效",
          "射击靶盖自动复位系统，简化操作过程",
          "无线数据传输，稳定、可靠、便捷",
          "智能比赛系统，实时监测比赛全程",
          "毫秒级比赛计时系统，精准可靠",
        ],
        introImgs: [
          {
            imgs: "../static/target_10m_qbp5.png",
            description: "XXXX靶场10米声学靶",
          },
        ],
      },
      {
        title: "军/警用电子靶",
        subTitle: "STPA",
        intro: ["速得尔军/警用电子靶系统STPA是中国射击协会认证的电子靶系统。"],
        foundImg: "../static/foundjingyong.png",
        icon: "../static/shengxue.png",
        tags: [
          "CSA认证",
          "高精度",
          "高可靠性",
          "高性价比",
          "全国赛事考验",
          "市场主导",
        ],
        merits: [
          "STPA适用于所有军事射击训练和比赛项目",
          "比赛控制系统支持常规军警项目",
          // "最佳性价比的声学电子靶系统",
          "更容易操控的触控屏",
          "竞赛及训练的理想设备",
          "经过中国射击协会认证",
        ],
        introImgs: [
          {
            imgs: "../static/target_10m_qbp5.png",
            description: "速得尔军/警用电子靶",
          },
        ],
      },
      {
        title: "射箭靶",
        subTitle: "A70L",
        intro: [""],
        foundImg: "../static/shejianba.png",
        icon: "../static/shengxue.png",
        tags: [
          "CSA认证",
          "高精度",
          "高可靠性",
          "高性价比",
          "全国赛事考验",
          "市场主导",
        ],
        merits: [
          "由公司众位博士精心打造",
          "可更换靶心区域结构",
          "符合国际射箭联合会规则标准",
          "采用光学技术处理方案实现高精度报靶",
          "靶心主体结构利用复合材料可达到10万次射击",
          "测量精度高，可达0.05环",
          "测量速度快，单次测量报靶时间和重复测量时间短",
        ],
        introImgs: [
          { imgs: "../static/target_10m_qbp5.png", description: "射箭靶" },
        ],
      },
      {
        title: "300米军用自动报靶系统",
        subTitle: "ST300T",
        intro: ["速得尔300米军用自动报靶系统ST300T可应用于军事五项赛前训练及比赛场景。"],
        foundImg: "../static/300mjingyong.png",
        icon: "../static/shengxue.png",
        tags: [
          "CSA认证",
          "高精度",
          "高可靠性",
          "高性价比",
          "全国赛事考验",
          "市场主导",
        ],
        merits: [
          "成熟的声学检测技术",
          "先进的防弹防反弹技术",
          "可靠的有线组网方式",
          "ISO9001质量体系认证",
          "应用于军事五项赛前训练及比赛场景",
          "国际军体射击世界锦标赛的300m步枪卧射和三姿射击项目",
          "后台支持：网上报名，网上直播，超级射手，大数据分析",
          "报靶偏差:2.5毫米",
          "射击成绩实时显示，有打印功能",
          "显示器10.2寸，显示射击人员信息、成绩、弹序、环数(小数点后1位)靶面命中点位",
          "测试精度：0.05环",
          "工作环境：-20℃—50℃，相对湿度20%-90%",
          "工作电压：AC220V/0.5A",
          "耗材：靶标（EVA泡沫）",
          "适用弹径：5.8mm、7.62mm、9.0mm等",
          "射击距离：100m至300m"        ],
        introImgs: [
          {
            imgs: "../static/target_10m_qbp5.png",
            description: "速得尔军/警用电子靶",
          },
        ],
      },
    ],

  },
  shoot: {
    //激光射击数据信息
    secondnav: [
      {
        title: "少儿激光射击系统10米P型",
        icon: "../static/sp-1.png",
        activeIcon: "../static/sp-2.png",
        index: 0,
      },
      {
        title: "少儿激光射击系统10米R型",
        icon: "../static/sr-1.png",
        activeIcon: "../static/sr-2.png",
        index: 1,
      },
      {
        title: "专业激光射击系统10米P型",
        icon: "../static/p-1.png",
        activeIcon: "../static/p-2.png",
        index: 2,
      },
      {
        title: "专业激光射击系统10米R型",
        icon: "../static/R-1.png",
        activeIcon: "../static/R-2.png",
        index: 3,
      },
    ],
    title: "激光射击",
    titleIcon: "../static/jiguangshouqiang.jpg",
    tabs: [
      {
        title: "少儿激光射击系统10米P型",
        subTitle: "SY10P",
        intro: [
          "少儿激光模拟运动射击训练辅助系统（以下简称少儿激光射击系统），是由速得尔专业电子靶研发团队，结合射击运动的发展趋势与需求，独立研发的专业射击辅助训练系统。激光射击系统继承了速得尔电子靶系统，精准，便捷可靠性高的特点，采用多项原创专利性设计，充分满足了射击训练中对安全性和高度模拟性的要求。",
        ],
        foundImg: "../static/shaoershouqiang.png",
        tags: ["欧盟认证", "公安部认证", "一类安全激光", "轨迹", "高精度"],
        merits: [
          "适合10米气手枪的模拟训练和比赛",
          "获得公安部软件系统安全认证",
          "重量轻，尺寸小，更适合少年运动员",
          "报靶精度满足ISSF及中国射击协会要求",
          "无缝接入速得尔电子靶软件系统",
          "安装方便、操作简单",
        ],
        introImgs: [
          {
            imgs: "../static/target_10m_qbp5.png",
            description: "配激光模拟射击图片和文字说明",
          },
        ],
      },
      {
        title: "少儿激光射击系统10米R型",
        subTitle: "SY10R",
        intro: [
          "少儿激光模拟运动射击训练辅助系统（以下简称少儿激光射击系统），是由速得尔专业电子靶研发团队，结合射击运动的发展趋势与需求，独立研发的专业射击辅助训练系统。激光射击系统继承了速得尔电子靶系统，精准，便捷可靠性高的特点，采用多项原创专利性设计，充分满足了射击训练中对安全性和高度模拟性的要求。",
        ],
        foundImg: "../static/shaoerbuqiang.png",
        tags: ["欧盟认证", "公安部认证", "一类安全激光", "轨迹", "高精度"],
        merits: [
          "适合10米气步枪的模拟训练和比赛",
          "获得公安部软件系统安全认证",
          "重量轻，尺寸小，更适合少年运动员",
          "报靶精度满足ISSF及中国射击协会要求",
          "无缝接入速得尔电子靶软件系统",
          "安装方便、操作简单",
        ],
        introImgs: [
          {
            imgs: "../static/target_10m_qbp5.png",
            description: "配激光模拟射击图片和文字说明",
          },
        ],
      },
      {
        title: "专业激光射击系统10米P型",
        subTitle: "SL10P",
        intro: [
          "首款可用于正式比赛的专业激光射击系统，高度还原真实运动气手枪体验，可记录瞄准轨迹，无缝接入速得尔电子靶系统，是射击运动选材与普及的利器。",
        ],
        foundImg: "../static/jiguangshouqiang.png",
        tags: ["欧盟认证", "公安部认证", "一类安全激光", "轨迹", "高精度"],
        merits: [
          "适合各类10米气手枪的模拟训练和比赛",
          "获得公安部软件系统安全认证",
          "获得欧盟安全激光认证（Class1）",
          "高度模拟真实运动枪支体验",
          "报靶精度满足ISSF及中国射击协会要求",
          "无缝接入速得尔电子靶软件系统",
          "安装方便、操作简单",
        ],
        introImgs: [
          {
            imgs: "../static/target_10m_qbp5.png",
            description: "配激光模拟射击图片和文字说明",
          },
        ],
      },
      {
        title: "专业激光射击系统10米R型",
        subTitle: "SL10R",
        intro: [
          "首款可用于正式比赛的专业激光射击系统，高度还原真实运动气步枪体验，可记录瞄准轨迹，无缝接入速得尔电子靶系统，是射击运动选材与普及的利器。",
        ],
        foundImg: "../static/jiguangbuqiang.png",
        tags: ["欧盟认证", "公安部认证", "一类安全激光", "轨迹", "高精度"],
        merits: [
          "适合各类10米气步枪的模拟训练和比赛",
          "获得公安部软件系统安全认证",
          "获得欧盟安全激光认证（Class1）",
          "高度模拟真实运动枪支体验",
          "报靶精度满足ISSF及中国射击协会要求",
          "无缝接入速得尔电子靶软件系统",
          "安装方便、操作简单",
        ],
        introImgs: [
          {
            imgs: "../static/target_10m_qbp5.png",
            description: "配激光模拟射击图片和文字说明",
          },
        ],
      },
    ],
  },
  erange: {
    //智能靶场数据信息
    secondnav: [
      {
        title: "智能枪弹柜",
        icon: "../static/gui-2.png",
        activeIcon: "../static/gui.png",
        index: 0,
      },
    ],
    title: "智能枪弹柜",
    titleIcon: "../static/jiguang.png",
    tabs: [
      {
        title: "智能枪弹柜",
        subTitle: "SGBM",
        intro: [
          "速得尔枪弹柜系统SGBM是速得尔公司在充分了解运动枪弹管理的用户需求基础上，开发出来的符合监管要求的运动枪弹管理和储存系统。整个产品系列包含运动枪柜SGBM-Q-V10、运动弹柜SGBM-D-V10和控制柜SGBM-K-V10。本系统以安全和可追溯为目标，充分考虑了射击训练与竞赛的需求。该系统可与速得尔电子靶系统配合，使枪弹管理更加精细化。",
          "速得尔枪弹柜系统SGBM采用标准接口，可与其它安防系统如门禁、闸机、人脸识别、RFID系统等集成。速得尔可提供符合国家安全标准的运动枪弹库的信息化和安全管理的整体解决方案，已有多处成功实施经验。",
        ],
        foundImg: "../static/zhinengqiangdangui.png",
        tags: ["安全", "可追溯", "公安部认证", "靶场精细化管理"],
        merits: [
          "采用多重警报与应急设置，防止、监控意外情况发生",
          "与速得尔电子靶系统无缝结合",
          "采用生物识别与RFID技术，实现快速精确身份识别和枪弹跟踪",
          "采用总线加密通信与信息实时存档确保信息安全",
          "了解监管要求，方便监管接入",
          "深刻理解日常使用场景，在安全管理的前提下，方便用户使用",
          "枪柜、弹柜及管理软件都获得了公安部认证",
        ],
        introImgs: [
          {
            imgs: "../static/target_10m_qbp5.png",
            description: "配智能靶场图片和文字说明",
          },
        ],
      },
    ],
  },
  service: {
    //软件与服务数据信息
    secondnav: [
      {
        title: "比赛模拟系统",
        icon: "../static/bsmn-1.png",
        activeIcon: "../static/bsmn-2.png",
        name: "supershooter",
        index: 0,
      },
      {
        title: "激光测试仪",
        icon: "../static/jgcsy-1.png",
        activeIcon: "../static/jgcsy-2.png",
        name: "supershooter",
        index: 1,
      },
      {
        title: "超级射手",
        icon: "../static/super-shoter.png",
        activeIcon: "../static/super-shoter-fill.png",
        name: "supershooter",
        index: 2,
      },
      {
        title: "赛事直播",
        icon: "../static/saishiplay.png",
        activeIcon: "../static/saishiplay-fill.png",
        name: "live",
        index: 3,
      },
      {
        title: "大数据训练辅助",
        icon: "../static/data.png",
        activeIcon: "../static/data-fill.png",
        name: "bigdata",
        index: 4,
      },
      {
        title: "赛事服务",
        icon: "../static/cup.png",
        activeIcon: "../static/cup-fill.png",
        name: "competitionservice",
        index: 5,
      },
      {
        title: "售后服务",
        icon: "../static/service.png",
        activeIcon: "../static/service-fill.png",
        name: "aftersaleservice",
        index: 6,
      },
      {
        title: "资料下载",
        icon: "../static/download.png",
        activeIcon: "../static/download-fill.png",
        name: "download",
        index: 7,
      },
    ],
    tabs: [
      {
        title: "比赛模拟系统",
        subTitle: "COMPETITION SIMULATION SYSTEM",
        intro: [
          "速得尔射击比赛模拟系统是一个真实运动员和虚拟运动员进行比赛，并进行实时排名的比赛模拟训练系统，在多媒体气氛的渲染下，在专业比赛播报的指令下，体验决赛，锤炼技能，磨砺心理，冲击金牌！",
        ],
        foundImg: "../static/monibisaisheji.png",
        icon: "../static/shengxue.png",
        merits: [
          "模拟真实赛事，让运动员与顶尖高手同台竞技",
          "多媒体渲染赛场氛围，提高队员心理抗压能力",
          "随机事件考验队员心理反应与调整能力",
          "搜集潜在对手的数据，提前适应，知己知彼",
          "采集全方位数据，科学分析，建立模型",
          "找到影响赛场成绩的关键因素，提高赛场成绩",
          "考核队员，发现“大赛型”选手",
        ],
        introImgs: [],
      },
      {
        title: "激光测试仪",
        subTitle: "LASER TEST INSTRUMENT",
        intro: [
          "速得尔激光测试仪即射击训练系统（SSTS），是一款专业的射击运动辅助训练系统，它可以帮助运动员和教练员进行针对性训练，提升训练效率，快速提高成绩。看齐国际先进技术，紧密融合电子靶系统，为射击科学训练和科学选材提供更加高效的技术支撑。",
        ],
        foundImg: "../static/jiguangceshiyi.png",
        icon: "../static/shengxue.png",
        merits: [
          "#应用场景",
          "室内、室外环境适用",
          "空枪预习、实弹射击",
          "测量距离10米、25米、50米全系列",
          "#产品特色：",
          "高精度瞄点轨迹跟踪",
          "扳机击发状态实时检测",
          "支持空枪预习和实弹射击",
          "适用于电子靶和机械靶",
          "多品牌枪支适配、国际射联比赛项目适配",
          "轨迹数据和报靶结果数据关联存储，实现大数据分析",
          "#产品优势：",
          "定期免费升级、无缝对接电子靶系统",
          "与报靶系统适配、支持自动校正、提高精度和便捷性",
          "本土化产品和服务、定期巡检、7×24小时全方位售后服务",
        ],
        introImgs: [],
      },
      {
        title: "超级射手",
        subTitle: "SUPER SHOOTER",
        intro: [
          "速得尔超级射手是全球首款运动射击竞训数据平台。超级射手拥有赛事直播、弹着分析和线上比赛三大功能，是射击运动员与教练员必备的训练辅助系统。",
        ],
        foundImg: "../static/chaojisheshou.png",
        icon: "../static/shengxue.png",
        ewm: {
          img: "../static/erweima-chaojisheshou.png",
          intro: "请扫码进入超级射手",
        },
        tags: [
          "CSA认证",
          "高精度",
          "高可靠性",
          "高性价比",
          "全国赛事考验",
          "市场主导",
        ],
        merits: [
          "全球首款运动射击竞训数据平台",
          "随时随地查看比赛训练情况",
          "完整展示弹着点分布、辅助训练",
          "观看重要赛事直播",
          "创建比赛、线上约战",
          "手机注册即用，无需安装APP",
        ],
        introImgs: [],
      },
      {
        title: "赛事直播",
        subTitle: "LIVE MATCHES",
        foundImg: "../static/saishizhibo.png",
        intro: [
          "首款射击比赛互联网直播系统，免费观看全国及省级射击比赛。曾在第十三届全运会上通过互联网为全国观众直播全运会射击比赛。",
        ],
        tags: [
          {
            title: "免费",
            icon: "../static/mainfei.png",
          },
          {
            title: "注册可用",
            icon: "../static/xinxi.png",
          },
          {
            title: "全部赛事",
            icon: "../static/bisai-cup.png",
          },
        ],
        merits: [
          "全国首款射击赛事比分直播系统",
          "获得十三届全运会组委会嘉奖",
          "可观看全国及省级比赛即时比分",
          "免费使用，无需安装注册",
        ],
        introImgs: [
          {
            imgs: "../static/chengabn.png",
            description: "速得尔获得十三届全运会组委会嘉奖",
          },
        ],
      },
      {
        title: "大数据训练辅助",
        subTitle: "BIG DATA SERVICE FOR SHOOTING SPORTS",
        foundImg: "../static/dashujufuwu2.png",
        intro: [
          "速得尔有丰富的射击数据，包括近5年国内正式比赛数据。在此基础上，由著名射击运动大数据专家牵头，利用数据分析技术帮助训练，提高竞赛水平",
        ],
        meritsTitle: "特色",
        merits: [
          "全国著名教练牵头组织",
          "以全国各项赛事300多万组数据为基础",
          "结合现代生物学、体育心理学",
          "为客户制定个性化成绩提升方案",
          "已为全国多地射击队提供服务",
        ],
        introImgs: [
          { imgs: "../static/chengabn.png", description: "射击数据分析示例" },
        ],
      },
      {
        title: "赛事服务",
        subTitle: "COMPETITION SERVICE",
        intro: [
          "速得尔赛事服务团队每年服务全国50多场射击赛事，经验丰富，态度严谨，专业技术过硬，曾获得过十三届全运会组委会《优秀赛事承办单位》称号。",
        ],
        foundImg: "../static/saishifuwu.png",
        merits: [
          "多次获得全国及省级比赛优秀保障团队奖",
          "每年支持50多场射击比赛",
          "团队包括4位北京市一级射击裁判",
          "熟悉国际射联最新规则",
          "熟悉国内外所有电子靶及比赛设备的操作",
        ],
      },
      {
        title: "售后服务",
        subTitle: "SUPPORT & SERVICE",
        intro: [
          "速得尔售后服务团队为客户提供包括设备安装、用户培训和定期巡检在内的全方位服务。",
        ],
        foundImg: "../static/shouhoufuwu.png",
        merits: ["7×24小时全方位售后服务", "定期产品巡检", "年度产品培训"],
      },
      {
        title: "产品指南",
        subTitle: "PRODUCT MANUAL",
        intro: ["User Manual for Suooter Electronic System Target"],
        merits: [],
        downlist: [
          {
            title: "Instructions for Suooter EST_EN_rev2.1.pdf",
            url: "/static/files/Instructions for Suooter EST_EN_rev2.1.pdf",
          },
        ],
      },
    ],
  },
  about: {
    //关于我们
    secondnav: [
      {
        title: "企业介绍",
        icon: "../static/qiye-line.png",
        activeIcon: "../static/qiye-fill.png",
        name: "intro",
      },
      {
        title: "企业荣誉",
        icon: "../static/rongyu-line.png",
        activeIcon: "../static/rongyu-fill.png",
        name: "honor",
      },
      {
        title: "战略客户",
        icon: "../static/kehu-line.png",
        activeIcon: "../static/kehu-fill.png",
        name: "customer",
      },
      {
        title: "加入我们",
        icon: "../static/rongyu-line.png",
        activeIcon: "../static/rongyu-fill.png",
        name: "recruit",
      },
      {
        title: "联系我们",
        icon: "../static/lianxi-line.png",
        activeIcon: "../static/lianxi-fill.png",
        name: "contact",
      },
    ],
    intro: {
      foundImg: "../static/guanyu-banner.png",
      merits: [
        "速得尔是中国射击装备领域的领导品牌。自2012年成立至今，速得尔已经形成了以电子靶自动报靶系统、激光模拟射击系统、智能枪弹管理系统为核心的产品体系。公司先后获得了国家高新技术企业认证、国家体育产业示范单位、第十三届全运会优秀赛事承办单位、中国射击协会认证电子靶提供商等多项荣誉称号。依托强大的研发实力和完善的赛事服务体系，速得尔获得了用户的广泛认可，产品遍及全国29个省市自治区的200多个用户，全国市场占有率超过60%。2018年10月速得尔获国际射联认证，电子靶产品首次出口海外。2021年，中国射击队在东京奥运会上表现卓越，速得尔作为技术服务提供商受到了相关领导的书面表扬。8月初，速得尔激光枪通过国际现代五项联盟（UIPM）认证，获得了服务奥运会和国际大赛的资格。",
      ],
      intro: "",
    },
    honor: {
      tags: [
        {
          title: "2021",
          subtitle: "国家体育总局东京奥运会射击项目取得佳绩感谢信",
          foundImg: "../static/r-img-9.png",
        },
        {
          title: "2020",
          subtitle: "国家高新技术企业证书",
          foundImg: "../static/r-img-8.png",
        },
        {
          title: "2019",
          subtitle: "第七届世界军人运动会荣誉证书",
          foundImg: "../static/r-img-7.png",
        },
        {
          title: "2018",
          subtitle: "10米光学电子靶通过国际射联（ISSF）一级认证",
          foundImg: "../static/r-img-6.png",
        },
        {
          title: "2017",
          subtitle: "第十三届全运会《优秀赛事承办单位》",
          foundImg: "../static/r-img-1.png",
        },
        {
          title: "2016",
          subtitle:
            "速得尔获得全国U17射击锦标赛，全国大学生射击锦标赛特别贡献奖。",
          foundImg: "../static/r-img-2.png",
        },
        {
          title: "2015",
          subtitle:
            "速得尔先后获得中关村高成长企业TOP100和北京市诚信创建企业等多项称号。",
          foundImg: "../static/r-img-3.png",
        },
        {
          title: "2014",
          subtitle: "速得尔获得国家级高新技术企业称号。",
          foundImg: "../static/r-img-4.png",
        },
        {
          title: "2013",
          subtitle:
            "速得尔电子靶系统通过中国射击协会认证，成为首家获得认证的企业。",
          foundImg: "../static/r-img-5.png",
        },
      ],
    },
    customer: {
      title: "战略客户",
      subtitle: "",
      foundImg: "../static/map.png",
      meritsTitle: "战略客户",
      merits: [
        "贵州毕节市体育运动学校",
        "安徽省射击运动管理中心",
        "陕西省射击射箭运动管理中心",
        "河北张家口少业余运动学校",
        "河南省射击射箭运动管理中心",
        "浙江杭州射击运动管理中心",
        "湖北省体育局射击运动管理中心",
        "四川成都运动学校",
        "云南省北教场体育训练基地",
        "湖南省射击运动管理中心",
        "福建省射击射箭运动管理中心",
        "江苏省方山体育训练基地",
        "山东省济宁市体育局",
        "甘肃兰州体育运动学校",
        "江西南昌湾里射击中心",
        "黑龙江省射击射箭运动管理中心",
        "新疆克拉玛依体育局",
      ],
    },
  },
};



// WEBPACK FOOTER //
// ./src/assets/js/zh.js